var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class SpoilerManager {
  constructor() {
    __publicField(this, "spoilers", {});
    __publicField(this, "registerSpoiler", (id, notifySpoiler) => {
      if (!this.spoilers[id]) {
        this.spoilers[id] = { isActive: true, notifiers: [] };
      }
      this.spoilers[id].notifiers.push(notifySpoiler);
    });
    __publicField(this, "toggleSpoiler", (id) => {
      this.spoilers[id].isActive = !this.spoilers[id].isActive;
      this.spoilers[id].notifiers.forEach((notifySpoiler) => notifySpoiler());
    });
    __publicField(this, "isActive", (id) => this.spoilers[id]?.isActive);
  }
}
var SpoilerManager_default = SpoilerManager;
export {
  SpoilerManager_default as default
};
//# sourceMappingURL=SpoilerManager.js.map
